// extracted by mini-css-extract-plugin
export default {"referral-widget":"qm","referral-page":"rm","label":"sm","subHed":"tm","profile-container":"um","referral-container":"vm","referral-header":"wm","shareMethodRow":"xm","shareMethod":"ym","active":"zm","referral-stat":"Am","blockwrapper":"Bm","referralLink":"Cm","bold":"Em","semibold":"Fm","shareAgainButton":"Gm","policy":"Hm","narrowWrapper":"Im"};
    if(module.hot) {
      // 1713912562818
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  